/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ product: NonNullable<unknown> }} Pwf_TitleInputs */

const en_pwf_title = /** @type {(inputs: Pwf_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Workflow of ${i?.product}`)
};

const de_pwf_title = /** @type {(inputs: Pwf_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Workflow von ${i?.product}`)
};

/**
* | output |
* | --- |
* | "Workflow of {product}" |
*
* @param {Pwf_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_title = /** @type {((inputs: Pwf_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_title(inputs)
	return en_pwf_title(inputs)
});